/*
**	Share Actions (Jotai-based)
*/

import { OldApiTypes } from 'common';
import { DisplayInsertInfo } from '@src/types/share';
import { api } from '../services/api';
import {
  openSharePopup,
  closeSharePopup,
  openSharePrompt,
  closeSharePrompt,
  setDisplayPreview,
  setInsertedDisplayPreviewContent,
  setPublishing,
  setPublishError,
} from '@src/state/shareAtoms';

// Re-export atom setters so existing imports keep working
export {
  openSharePopup,
  closeSharePopup,
  openSharePrompt,
  closeSharePrompt,
  setDisplayPreview,
};

export function publishedFailed(error: string): void {
  setPublishError(error);
}

export async function publish(data: OldApiTypes.Share.IBodyPublish): Promise<void> {
  setPublishing();
  const res = await api.publish(data);
  if (res !== 'ok') {
    throw new Error(res as string);
  }
}

export async function loadDisplayPreview(): Promise<void> {
  const displayPreview = await api.getDisplayPreview();
  setDisplayPreview(displayPreview);
}

export async function insertItemInToDisplay(info: DisplayInsertInfo, position: number): Promise<void> {
  const content = await api.insertItemInToDisplay(info, position);
  setInsertedDisplayPreviewContent(content);
}

